// extracted by mini-css-extract-plugin
export default {"headerNav":"Nav_headerNav__Bqs+t","navLogo":"Nav_navLogo__6s0Uh","navLink":"Nav_navLink__vF0yb"};